import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: []
})
export class ErrorModalComponent {

    public message: string;
    public withCloseBtn: boolean;

    constructor(private instance: NgbActiveModal) { }

    public Close() {
        this.instance.close();
    }
}
